import { ExportModal } from '@/views/analysis/ExportModal/ExportModal';
import type { GroupAnalysisType } from '@/generated/types/navigator/types.gen';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import { useCallback } from 'react';

interface Props {
  showExportModal?: boolean;
  onClose?: () => void;
  projectId: string;
  selectedAnalysis: GroupAnalysisType;
}

export const ProjectExport = ({
  showExportModal,
  onClose,
  selectedAnalysis,
  projectId,
}: Props) => {
  const intl = useClientTerminology();

  const getTrackingSuffix = useCallback(() => {
    return `${selectedAnalysis.toLocaleLowerCase()}_projects`;
  }, [selectedAnalysis]);

  const title = intl.formatMessage(
    { id: 'action.export' },
    {
      thing: intl.formatMessage({ id: 'noun.project' }),
    }
  );

  return (
    <ExportModal
      title={title}
      showExportModal={showExportModal}
      onClose={onClose}
      trackingSuffix={getTrackingSuffix()}
      exportEntityTranslationKey="noun.project"
      exportEndpoint={`/v1/analysis/level3/export/custom_list/${projectId}`}
      useGetMethod={true}
    />
  );
};
